export enum ShapeTokensEnum {
    RECTANGLE = "rectangle",
    PILL = "pill",
}
